import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { AuthComponent } from './auth.component';
import { OrganisationModalComponent } from '../../modals/organisation-modal/organisation-modal.component';

const routes: Routes = [
    {
      path: '', component: AuthComponent
    },

];

@NgModule({
  declarations: [
    OrganisationModalComponent
  ],
  imports: [
    RouterModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    FormsModule,
    RouterModule.forChild(routes)
  ]
})
export class AuthModule { }
